import styled from "@emotion/styled";
import { PRIMARY_BLACK } from "src/constants/colors";

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 16px;
  z-index: 2;
  margin: 20px 0 10px 0;
`;

export const TaskRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
`;

export const StatusIcon = styled.div`
  flex-shrink: 0;
  height: 12px;
  max-height: 12px;
  width: 12px;
  max-width: 12px;
  margin: 0px 5px 0px 3px;
  position: relative;

  & svg {
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
  }
`;

export const TeamMemberLabel = styled.div`
  flex-shrink: 0;
  color: ${PRIMARY_BLACK};
  font-size: 14px;
  font-weight: 500;
`;

export const TaskDetailLabel = styled.div`
  color: rgba(49, 57, 74, 1);
  font-size: 14px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const DotDivider = styled.div`
  flex-shrink: 0;
  background-color: rgba(74, 84, 102, 1);
  border-radius: 50%;
  height: 4px;
  width: 4px;
`;

export const DateLabel = styled.div`
  flex-shrink: 0;
  color: rgba(74, 84, 102, 1);
  font-size: 12px;
`;

export const NoTasksLabel = styled.div`
  color: rgb(74, 84, 102);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  padding: 20px;
`;

export const ProgressLine = styled.div`
  position: absolute;
  top: 8px;
  left: 8px;
  bottom: 5px;
  width: 2px;
  background-color: #f3f5f8;
  z-index: 0;
`;
